export default "/fonts/TiemposHeadline-Regular.ttf?b9c3ee3d87dcd959fb6ec5d9ea46d0c9";